import { useAuth } from './use-auth';

/**
 * Hook para obter o company_id correto baseado no contexto do usuário:
 * - Admins globais → Portal One company_id
 * - Usuários comuns → activeCompany.id
 */
export const useCompanyContext = () => {
  const { effectiveCompanyId, isGlobalAdmin, portalOneCompanyId, loading } = useAuth();

  return {
    companyId: effectiveCompanyId,
    isPortalOne: isGlobalAdmin,
    portalOneCompanyId,
    loading,
  };
};
